<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div v-if="!isProcessing">
    <DiagCorpHeader
      v-if="!isRendering"
      :corpName="latestDiagResult.corpNm"
      :corporateFeatureInfoLabels="latestDiagResult.corporateFeatureInfoLabels"
      :corporateSelectable="isAdmin"
      :manageCorpName="manageCorpName"
      :isAdmin="isAdmin"
      :isDiagAvailablePlan="isDiagAvailablePlan"
      @select-corporate="emitSelectCorpList"
    ></DiagCorpHeader>
    <DiagHeader
      :score="latestDiagResult.score"
      :totalScore="latestDiagResult.totalScore"
      v-if="latestDiagResult.diagResultId"
      @emit-diag-title-change="changeDiagTitle"
    ></DiagHeader>

    <div class="l-contents" v-if="!isRendering">
      <DiagNavigation
        :isAdmin="isAdmin"
        :isIpo="isIpo"
      ></DiagNavigation>
      <template v-if="!isRendering">

        <!-- 監査がある場合(diagResultId!=null) -->
        <template v-if="latestDiagResult.diagResultId">
          <!-- 監査はあるが監査結果がない場合(latestDiagResult.hasVerifiedItem==null) -->
          <div class="l-contentsBox l-resultBox" v-if="!latestDiagResult.hasVerifiedItem">
            <p><img src="@/assets/img/common/icon-nav1_blue.svg" alt="" width="28"></p>
            <h3 class="l-headding is-blue">監査結果はまだありません</h3>
            <p class="l-text">診断フォームで回答し、専門家ユーザーが確認した回答結果がここ反映されます。</p>
            <div v-if="isAdmin" class="btn-basic is-inlne is-primary mt-30" @click="goDiagForm()"><a>診断フォームへ</a></div>
          </div>
          <div v-else class="l-contentsBox">
            <div class="l-contentsBox no-border">
              <div class="l-contentsTitle is-noicon">
                <h2 class="l-contentsTitle__text">監査結果<time>{{ $dayjs(latestDiagResult.diagResultLastUpdateDate).format("YYYY年MM月DD日 HH時mm分") }}</time><span>更新</span></h2>
<!--                <div class="btn-report"><a @click="exportResult(diagResultId)">レポートダウンロード</a></div>-->
              </div>

              <div v-show="!isProxy">
                <DiagAuditTable
                  :isProxy="isProxy"
                  :showDownload="isAdmin || (!isAdmin && latestDiagResult.canDownloadExcel)"
                  :isIpo="isIpo"
                  :canDownloadExcel="latestDiagResult.canDownloadExcel"
                  :isAdmin="isAdmin"
                  :score="latestDiagResult.score"
                  :totalScore="latestDiagResult.totalScore"
                  @emit-diag-title-change="changeDiagTitle"
                ></DiagAuditTable>

              <!-- 代理店時は表示しない -->
                <div class="completion-header">
                  <div class="completion-rate" v-show="latestDiagResult.hasVerifiedItem">
                    <p class="completion-rate__label">達成度</p>
                    <p class="completion-rate__data"><strong>{{ progress }}</strong>%</p>
                    <img v-if="latestDiagResult.diagResultMonthOverMonth == 'up'" src="@/assets/img/common/icon-up.svg" alt="" style="width: 15px;height: 15px;margin-left: 5px;">
                    <img v-else-if="latestDiagResult.diagResultMonthOverMonth == 'down'" src="@/assets/img/common/icon-down.svg" alt="" style="width: 15px;height: 15px;margin-left: 5px;">
                    <div class="progress_bar is-long"><span :style="'width: ' + progress + '%' "></span></div>
                    <p class="completion-rate__data">{{ latestDiagResult.score }} / {{ latestDiagResult.totalScore }}点</p>
                  </div>

                  <p class="l-text-small" v-if="isIpo">IPO重要度とは
                    <span class="icon-help"
                      data-tooltip=""
                      @mouseover="toggle('ipo')" @mouseleave="toggleb('ipo')">
                      <span id="ipo" class="tooltip is-top">IPO重要度<br>弊法人独自の基準により、問題が顕在化した場合の「財務的影響度」、「課題解決の難易度」及び「対応の緊急度」を考慮して、労務リスクの「重要度」を4つのレベル(LV)に評価・分類しています。<br>
                        詳しくは<a href="https://support.roumu-kansa.jp/faq/2844419.html" target="_blank">サポートサイト</a>をご確認ください。</span><img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
                    </span>
                  </p>
                </div>

                <!-- 監査円グラフ -->
                <CompletionGraph ref="graph" :results = "latestDiagResult.diagSectionScores" v-if="!isProxy && !this.latestDiagResult.sectionNotUseFlag && !isIpo && !isProcessing"/>

                <!-- IPO監査円グラフ -->
                <CompletionGraphIpo ref="graphIpo" :results = "latestDiagResult.diagSectionScores" v-if="!isProxy && !this.latestDiagResult.sectionNotUseFlag && isIpo && !isProcessing"/>
              </div>

              <!-- 代理店 -->
              <div v-show="isProxy">
                <DiagAuditTable
                  :isProxy="isProxy"
                  :showDownload="isAdmin || (!isAdmin && latestDiagResult.canDownloadExcel)"
                  :isIpo="isIpo"
                  :canDownloadExcel="latestDiagResult.canDownloadExcel"
                  :isAdmin="isAdmin"
                  :score="latestDiagResult.score"
                  :totalScore="latestDiagResult.totalScore"
                  @emit-diag-title-change="changeDiagTitle"
                ></DiagAuditTable>

                <div class="achievement" style="border-bottom: 1px solid #cecece;" v-show="latestDiagResult.hasVerifiedItem">
                  <p>達成度<span>{{ progress }}</span>％</p>
                  <img v-if="latestDiagResult.diagResultMonthOverMonth == 'up'" src="@/assets/img/common/icon-up.svg" alt="" style="width: 15px;height: 15px;margin-left: 5px;">
                  <img v-else-if="latestDiagResult.diagResultMonthOverMonth == 'down'" src="@/assets/img/common/icon-down.svg" alt="" style="width: 15px;height: 15px;margin-left: 5px;">
                  <div class="progress_bar"><span :style="'width: ' + progress + '%' "></span></div>
                  <p>{{ latestDiagResult.score }} / {{ latestDiagResult.totalScore }}点</p>
                </div>
              </div>

              <!-- 優先度の高い課題 -->
              <template v-if="latestDiagResult.hasRiskDiagResultItems.length > 0">
                <div class="l-contentsSection">
                  <h3 class="l-headding is-blueline">優先度の高い課題</h3>
                  <table class="table-base audit-table table-select">
                    <colgroup>
                      <col style="width: 50px;" v-if="!isIpo">
                      <col style="width: 120px;" v-if="isIpo">
                      <col>
                      <col>
                      <col>
                    </colgroup>
                    <thead>
                      <tr>
                        <th v-if="!isIpo">リスク</th>
                        <th v-if="isIpo">IPO重要度</th>
                        <th>診断名</th>
                        <th class="t-center">優先度</th>
                        <th class="t-center">対応期限</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="diagResultItem in hasRiskDiagResultItemsCount" :key="diagResultItem.diagResultItemId" @click="goTaskDetail(diagResultItem.diagResultItemId)">
                        <td v-if="!isIpo">
                          <span class="label" :class="diagResultItem.riskLevelDisplayLabelClass" :data-tooltip="diagResultItem.riskLevelDescription" @mouseover="toggle('high-'+diagResultItem.diagResultItemId)" @mouseleave="toggleb('high-'+diagResultItem.diagResultItemId)">
                            <span class="tooltip is-right" :id="'high-'+diagResultItem.diagResultItemId" >{{diagResultItem.riskLevelDescription}}</span>
                            {{ diagResultItem.risk }}
                          </span>
                        </td>
                        <td v-if="isIpo">
                          <span class="label-level" :class="diagResultItem.ipoImportanceDisplayLabelClass" :data-tooltip="diagResultItem.ipoImportanceDescription" @mouseover="toggle('high-'+diagResultItem.diagResultItemId)" @mouseleave="toggleb('high-'+diagResultItem.diagResultItemId)">
                            <span class="tooltip is-right" :id="'high-'+diagResultItem.diagResultItemId" >{{diagResultItem.ipoImportanceDescription}}</span>
                            {{ diagResultItem.ipoImportance }}
                          </span>
                        </td>
                        <td>
                          <span class="number-text">
                            <span class="number">{{ diagResultItem.sortOrder }}</span>
                            <span class="text" style="white-space: pre-line;">{{ diagResultItem.task }}</span>
                          </span>
                        </td>
                        <td class="t-center">
                          <span v-if="diagResultItem.priority">高</span>
                          <span v-else>&nbsp;</span>
                        </td>
                        <td class="t-center" :class="{'caution' : diagResultItem.isCaution}">
                          <template v-if="diagResultItem.dueDate">
                            {{ $dayjs(diagResultItem.dueDate).format("YYYY年MM月DD日") }}
                            <img v-if="diagResultItem.isCaution" src="@/assets/img/common/icon-caution.svg" alt="" width="22" height="22">
                          </template>
                          <template v-else>未設定</template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </template>
              <template v-else>
                <div class="l-contentsSection">
                  <h3 class="l-headding is-blueline">優先度の高い課題</h3>
                  <p class="l-text">現在、対応が必要な課題はありません。</p>
                </div>
              </template>

              <!-- 最近解決した課題 -->
              <template v-if="latestDiagResult.taskListResolvedRecently.length > 0">
                <div class="l-contentsSection">
                  <h3 class="l-headding is-blueline">最近解決した課題</h3>
                  <div class="l-scroll-table" style="height: initial; max-height: 370px;">
                    <table class="table-base audit-table  table-select">
                      <colgroup>
                        <col style="width: 50px;" v-if="!isIpo">
                        <col style="width: 120px;" v-if="isIpo">
                        <col>
                        <col>
                      </colgroup>
                      <thead>
                        <tr>
                          <th v-if="!isIpo">リスク</th>
                          <th v-if="isIpo">IPO重要度</th>
                          <th>項目名</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="diagResultItem in latestDiagResult.taskListResolvedRecently" :key="diagResultItem.diagResultItemId" @click="goTaskDetail(diagResultItem.diagResultItemId)">
                          <td v-if="!isIpo">
                            <span class="label" :class="diagResultItem.diagItem.riskLevel.displayLabelClass" :data-tooltip="diagResultItem.diagItem.riskLevel.description" @mouseover="toggle(diagResultItem.diagResultItemId)" @mouseleave="toggleb(diagResultItem.diagResultItemId)">
                              <span class="tooltip is-right" :id="diagResultItem.diagResultItemId" >{{diagResultItem.diagItem.riskLevel.description}}</span>
                              {{ diagResultItem.diagItem.riskLevel.name }}
                            </span>
                          </td>
                          <td v-if="isIpo">
                            <span class="label-level" :class="diagResultItem.diagItem.ipoImportance.displayLabelClass" :data-tooltip="diagResultItem.diagItem.ipoImportance.description" @mouseover="toggle(diagResultItem.diagResultItemId)" @mouseleave="toggleb(diagResultItem.diagResultItemId)">
                              <span class="tooltip is-right" :id="diagResultItem.diagResultItemId" >{{diagResultItem.diagItem.ipoImportance.description}}</span>
                              {{ diagResultItem.diagItem.ipoImportance.name }}
                            </span>
                          </td>
                          <td>
                            <span class="number-text">
                              <span class="number">{{ diagResultItem.sortOrder }}</span>
                              <span class="text" style="white-space: pre-line;">{{ diagResultItem.diagItem.task }}</span>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="l-contentsSection">
                  <h3 class="l-headding is-blueline">最近解決した課題</h3>
                  <p class="l-text">現在、最近解決した課題はありません。</p>
                </div>
              </template>

              <!-- NOTE: 優先度の高い課題が存在するときに表示する -->
              <div class="l-btn-center" v-if="latestDiagResult.hasRiskDiagResultItems.length > 0">
                <div class="btn-basic" @click="goTaskList(latestDiagResult.diagResultId)"><a>すべての課題</a></div>
              </div>
            </div>
          </div>
          <div class="l-contentsBox" v-if="!isRendering">
            <div class="l-contentsBox no-border">
              <div class="l-contentsTitle is-noicon">
                <h2 class="l-contentsTitle__text">監査履歴</h2>
              </div>
              <div class="l-scroll-table" style="padding-top: 30px;">
                <table class="table-base audit-table table-select">
                  <thead>
                    <tr>
                      <th>監査名</th>
                      <th>診断プラン</th>
                      <th class="t-center">ダウンロード</th>
                      <th class="t-center">最終更新日時</th>
                      <th class="t-center">有効期限
                        <span class="icon-help" data-tooltip="" @mouseover="toggle('expired')" @mouseleave="toggleb('expired')">
                          <span class="tooltip is-right" id="expired" >1年以上更新が行われていない監査は、有効期限切れとなります。<br>有効期限切れとなった監査はすべての項目の「専門家の確認」のチェックがはずれ、達成率が０％となり、各種集計の対象から外れます。<br>再度、専門家ユーザーの確認を行ってください。</span>
                          <img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
                        </span>
                      </th>
                      <th class="t-center" v-if="isAdmin">複製</th>
                      <th class="t-center">削除</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="diagResult in diagResultList" :key="diagResult.diagResultId" @click="selectDiagResult(diagResult.diagResultId)">
                      <td>
                        {{ diagResult.title }}
                      </td>
                      <td :class="{ 'update' : diagResult.diagRevisionFlg }">
                        {{ diagResult.diagCourse.courseName }}
                      </td>
                      <td class="t-center">
                        <a class="link" @click="exportResult(diagResult.diagResultId)" v-if="isAdmin || (!isAdmin && diagResult.canDownloadExcel) || isProxy">
                          <img src="@/assets/img/common/icon-excel.svg" style="width: 22px;height: 22px;" alt="">
                        </a>
                      </td>
                      <td class="t-center">
                        {{ $dayjs(diagResult.diagResultLastUpdateDate).format("YYYY/MM/DD HH:mm") }}
                      </td>
                      <td class="t-center" :class="{'caution' : diagResult.diagExpiredFlg}">
                        <span v-if=diagResult.diagExpirationDate>{{ $dayjs(diagResult.diagExpirationDate).format("YYYY/MM/DD") }}</span>
                        <img src="@/assets/img/common/icon-caution.svg" alt="" width="22" height="22" v-if="diagResult.diagExpiredFlg">
                      </td>
                      <td class="t-center" v-if="isAdmin">
                        <div  class="btn-copy js-btn-copy" :data-text="diagResult.title" @click="copyDiag(diagResult.title , diagResult.diagResultId)"><a>複製</a></div>
                      </td>
                      <td class="t-center">
                        <div class="btn-delete js-btn-delete" :data-text="diagResult.title" @click="deleteDiag(diagResult.diagResultId)"><a>削除</a></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </template>
        <!-- 監査がない場合(diagResultId==null) -->
        <template v-else>
          <div class="l-contentsBox">
            <p class="l-text t-center">ヨクスルはクライアントの労務状況を簡単にチェックし、改善にむけた課題の管理を行うことができるサービスです。</p>
            <div>
              <img src="@/assets/img/tutorial/tutorial00.svg" alt="" style="width: 100%; display: block;max-width: 1200px;margin:30px auto 30px auto;">
            </div>

            <div class="l-contentsBox l-resultBox">
              <p><img src="@/assets/img/common/icon-nav1_blue.svg" alt="" width="28"></p>
              <h3 class="l-headding is-blue">監査はまだありません</h3>
              <div class="btn-basic is-inlne is-primary mt-30" @click="goNewDiag()"><a>監査を新規作成</a></div>
            </div>
          </div>
        </template>
      </template>
    </div>
    <transition name="diagtitlechange-fade">
      <DiagTitleChangeModal
        v-show="execChangeDiagTitle"
        :diagResultId="diagResultId"
        @cancel-diag-title-change="changeDiagTitle(false)"
      ></DiagTitleChangeModal>
    </transition>
    <transition name="tutorialmodal-fade">
      <DiagResultTutorial
        v-show="isShowTutorial"
        @close-tutorial-modal="showTutorialModal(false)"
      ></DiagResultTutorial>
    </transition>
    </div>
  </main>
</template>

<script src="https://code.jquery.com/jquery-3.5.1.min.js "></script>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import { saveAs } from "file-saver";
import DiagHeader from '@/components/parts/diag/DiagHeader.vue';
import DiagCorpHeader from '@/components/parts/diag/DiagCorpHeader.vue';
import constant from '@/const';
import DiagTitleChangeModal from '@/components/pages/diag/DiagTitleChangeModal.vue';
import DiagNavigation from '@/components/parts/diag/DiagNavigation.vue';
import DiagResultTutorial from '@/components/parts/tutorial/DiagResultTutorial.vue';
import DiagAuditTable from '@/components/parts/diag/DiagAuditTable.vue';
import CompletionGraph from '@/components/parts/human_capital/parts/CompletionGraph.vue';
import CompletionGraphIpo from '@/components/parts/human_capital/parts/CompletionGraphIpo.vue';

export default {
  components: {
    Loading,
    DiagHeader,
    DiagCorpHeader,
    DiagTitleChangeModal,
    DiagNavigation,
    DiagResultTutorial,
    DiagAuditTable,
    CompletionGraph,
    CompletionGraphIpo,
  },
  data() {
    return {
      isParamAccess: false,
      isProcessing: false,
      isRendering: false,
      diagResultList: [],
      latestDiagResult: {
        diagResultId: null,
        diagCourseId: null,
        title: '',
        courseName: '',
        hasRiskDiagResultItems: [],
        existExpiredUpCloseDiagResult: false,
        isOptionDiag: false,
        diagResultLastUpdateDate: null,
        hasVerifiedItem: false,
        diagSectionScores: [],
        taskListResolvedRecently: [],
        diagResultMonthOverMonth: '',
        sectionNotUseFlag: false,
      },
      employeeNumberTypeList: constant.EMPLOYEE_NUMBER_TYPE,
      employeeNumberType: "",
      execChangeDiagTitle: false,
      isAdmin: false,
      isDiagAvailablePlan: false,
      isShowTutorial: false,
      planId: {},
      isIpo: false,
    }
  },
  computed: {
    corpId() {
      return this.$store.getters['diag/getCorpId'];
    },
    diagResultId() {
      return this.$store.getters['diag/getDiagResultId'];
    },
    diagTitle() {
      return this.$store.dispatch('diag/getTitle');
    },
    progress() {
      return Math.floor((this.latestDiagResult.score / this.latestDiagResult.totalScore) * 100);
    },
    score() {
      return this.$store.getters['diag/getScore'];
    },
    totalScore() {
      return this.$store.getters['diag/getTotalScore'];
    },
    hasRiskDiagResultItemsCount() {
      return this.latestDiagResult.hasRiskDiagResultItems.slice(0, 5);
    },
    manageCorpName() {
      return this.$store.getters['auth/getUser'].manageCorpNm;
    },
    diagRevisionFlg() {
      return this.$store.getters['diag/getDiagRevisionFlg'];
    },
    isProxy() {
      return this.planId == 3; // 代理店
    }
  },
  // corpIdの監視　法人切替時に実行される
  watch: {
    async corpId() {
      this.isRendering = true;
      this.isProcessing = true;
      this.$store.dispatch('diag/setDiagResultId', null);
      await this.getLatestDiagResultForCorporate(this.corpId, this.diagResultId);
      await this.getDiagResultList(this.corpId);
      this.$nextTick(() => {
        this.isRendering = false;
        this.isProcessing = false;
      });
      this.$router.replace({path: '/diag/'+this.corpId+'/'+this.diagResultId+'/topparam'});
      if (this.$refs.radarChart) {
        this.$refs.radarChart.recreateChart(this.corpId, this.diagResultId);
      }
      if (this.$refs.achievementDistribution) {
        this.$refs.achievementDistribution.recreateGraph(this.corpId, this.diagResultId, this.employeeNumberType);
      }
      if (this.$refs.achievementHistoryBar) {
        this.$refs.achievementHistoryBar.createGraph(this.diagResultId);
      }
    },
    diagResultId() {
      this.$store.dispatch('diag/initEachSearchForm');
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);

    jQuery(function ($) {
      $(document).on('click', function() {
          $('.tooltip').fadeOut(200); // 画面のどこかがクリックされたときにツールチップを隠す
      });
    })
  },
  created: async function () {
    this.isRendering = true;
    this.isProcessing = true;

    // パラメータURLからのアクセスかどうかをフラグ値にする
    this.isParamAccess = ( this.$route.params.corpId != undefined && this.$route.params.diagResultId != undefined);

    // パラメータURLからのアクセスの場合は引き継いだ変数値を設定する
    if (this.isParamAccess) {
      // パラメータのチェック
      await this.checkParams(this.$route.params);
    }else{
      await this.common();
      this.isProcessing = false;
    }
  },
  methods: {
    toggle(id) {
      var tooltip = $('#'+id);
      tooltip.fadeIn(200);
    },
    toggleb(id) {
      var tooltip = $('#'+id);
      tooltip.fadeOut(200);
    },
    async common() {
      await this.getDiagResultList(this.corpId);
      await this.getLatestDiagResultForCorporate(this.corpId, this.diagResultId);

      const authority = await this.$store.dispatch('auth/getAuthority')
      this.isAdmin = authority.isAdmin;
      this.planId = authority.planId;
      this.isDiagAvailablePlan = authority.isDiagAvailablePlan;

      this.isParamAccess = false;
      this.$nextTick(() => {
        this.isRendering = false;
        this.isProcessing = false;
      });

      if (this.$refs.radarChart) {
        this.$refs.radarChart.recreateChart(this.corpId, this.diagResultId);
      }
      if (this.$refs.achievementDistribution) {
        this.$refs.achievementDistribution.recreateGraph(this.corpId, this.diagResultId, this.employeeNumberType);
      }
      if (this.$refs.achievementHistoryBar) {
        this.$refs.achievementHistoryBar.createGraph(this.diagResultId);
      }
      this.showTutorialModal(this.$store.getters['auth/getUser'].tutorial.isShowDiagResultTutorial);
    },
    async checkParams(params) {
      let res = await this.$axios.post('/ld/api/diag/checkParams', {
        corpId: params.corpId,
        diagResultId: params.diagResultId,
        diagResultItemId: null,
      });
      if (res.status === 500) {
        let res = await this.$axios.post('/ld/api/corporate/getClientCorporateList', {});
        if (res) {
          this.isProcessing = false;
          this.$store.dispatch('diag/setCorpId', res.data.corporateList[0].corpId);
          this.$store.dispatch('diag/setDiagResultId', null);
          this.$store.dispatch('diag/setDiagResultItemId', null);
          this.$toast.error('企業情報が見つからなかったので、Top画面に戻ります。');
          this.$router.push({ name: 'diag-top' });
        }
      }else{
        this.$store.dispatch('diag/setCorpId', params.corpId);
        await this.getCorporateFeatureInfoLabels(this.corpId);
        await this.getDiagResultTitle(this.diagResultId);
        await this.common();
        this.isProcessing = false;
      }
    },
    // 特徴データを取得して設定
    async getCorporateFeatureInfoLabels(corpId) {
      let res = await this.$axios.post('/ld/api/corporate/getCorporateFeatureInfoLabels', {
        corpId: corpId,
      });
      if (res) {
        this.$store.dispatch('diag/setCorporateFeatureInfoLabels', res.data.corporateFeatureInfoLabels);
      }
    },
    async getDiagResultTitle(diagResultId) {
      if (diagResultId) {
        let res = await this.$axios.post('/ld/api/diag/getDiagResultTitle', {
          diagResultId: diagResultId,
        });
        if (res.status==200) {
          this.$store.dispatch('diag/setTitle', res.data.diagTitle);
        }else{
          this.$toast.error(res.data.message);
        }
      }
    },
    async getLatestDiagResultForCorporate(corpId, diagResultId = null) {
      if (corpId) {
        let res = await this.$axios.post('/ld/api/diag/getLatestDiagResultForCorporate', {
          corpId: corpId,
          diagResultId: diagResultId,
        });
        if (res.status) {
          this.isIpo = res.data.latestDiagResult.isIpo;
          this.latestDiagResult = res.data.latestDiagResult;
          this.$store.dispatch('diag/setDiagResultId', this.latestDiagResult.diagResultId);
          this.$store.dispatch('diag/setTitle', this.latestDiagResult.title);
          this.$store.dispatch('diag/setDiagCourseName', this.latestDiagResult.courseName)
          this.$store.dispatch('diag/setCorpName', this.latestDiagResult.corpNm);
          this.$store.dispatch('diag/setScore', this.latestDiagResult.score);
          this.$store.dispatch('diag/setTotalScore', this.latestDiagResult.totalScore);
          this.$store.dispatch('diag/setDiagRevisionFlg', this.latestDiagResult.diagRevisionFlg);
          this.$store.dispatch('diag/setIsOptionDiag', this.latestDiagResult.isOptionDiag);
          this.$store.dispatch('diag/setSectionNotUseFlag', this.latestDiagResult.sectionNotUseFlag);
          this.$store.dispatch('diag/setCorporateFeatureInfoLabels', this.latestDiagResult.corporateFeatureInfoLabels);
          window.scrollTo({
            top: 0,
            behavior: "instant"
          });
        }else{
          this.$toast.error(res.data.message);
        }
      }
    },
    async getDiagResultList(corpId) {
      if (corpId) {
        let res = await this.$axios.post('/ld/api/diag/getDiagResultList', {
          corpId: corpId,
        });
        if (res) {
          this.diagResultList = res.data.diagResultList;
        }
      }
    },
    goDiagResult(diagResultId) {
      this.$store.dispatch('diag/setDiagResultId', diagResultId);
      this.$router.push({ name: 'diag-section-list', query: { diagCourseId: this.latestDiagResult.diagCourseId } });
    },
    async exportResult(diagResultId) {
      this.$toast.info('ダウンロードを開始しました。');
      await saveAs('/ld/api/diag/export?id=' + diagResultId);
    },
    goNewDiag() {
      this.$router.push({ name: 'diag-course-select' });
    },
    async copyDiag(title, diagResultId) {
      const answer = confirm('「' + title + '」を複製しますか？');

      if (!answer) return;

      this.isRendering = true;
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/diag/copyDiagResult', {
        diagResultId: diagResultId,
      });
      if (res.status === 200) {
        this.$toast.info('診断をコピーしました');

        await this.getDiagResultList(this.corpId);
        await this.selectDiagResult(res.data.newDiagResultId)

      } else {
        this.$toast.error('エラーが発生しました。');
      }
      this.$nextTick(() => {
        this.isRendering = false;
        this.isProcessing = false;
      });
    },
    goDiagManagementList(diagResultId) {
      this.$store.dispatch('diag/setDiagResultId', diagResultId);
      this.$router.push({ name: 'diag-management-list' });
    },
    goTaskList(diagResultId) {
      this.$store.dispatch('diag/setDiagResultId', diagResultId);
      this.$router.push({ name: 'task-list' });
    },
    // 監査結果がないときに表示される監査フォーム遷移ボタンの処理
    // 条表示・非表示の設定で表示画面が異なるため、分岐している
    goDiagForm() {
      this.$store.dispatch('diag/setDiagResultId', this.latestDiagResult.diagResultId);
      this.$store.dispatch('diag/setDiagCourseId', this.latestDiagResult.diagCourseId);
      this.$store.dispatch('diag/setSectionNotUseFlag', this.latestDiagResult.sectionNotUseFlag);

      if (!this.latestDiagResult.sectionNotUseFlag) {
        this.$router.push({ name: 'diag-section-list', query: { diagCourseId: this.latestDiagResult.diagCourseId } });
      } else {
        this.$router.push({ name: 'option-diag-answer-input', query: { diagCourseId: this.latestDiagResult.diagCourseId } });
      }
    },
    /**
     * 監査履歴リストからの移動処理
     */
    async selectDiagResult(diagResultId) {

      this.isRendering = true;
      this.isProcessing = true;

      this.$router.replace({path: '/diag/'+this.corpId+'/'+diagResultId+'/topparam'});

      // diagResultIdがnullでない場合は、diagResultIdの監査結果を、nullの場合は最終更新監査結果を取得する
      await this.getLatestDiagResultForCorporate(this.corpId, diagResultId);

      this.$nextTick(() => {
        this.isRendering = false;
        this.isProcessing = false;
      });

      if (this.$refs.radarChart) {
        this.$refs.radarChart.recreateChart(this.corpId, diagResultId);
      }
      if (this.$refs.achievementDistribution) {
        this.$refs.achievementDistribution.recreateGraph(this.corpId, diagResultId, this.employeeNumberType);
      }
      if (this.$refs.achievementHistoryBar) {
        this.$refs.achievementHistoryBar.createGraph(diagResultId);
      }

    },
    // 優先度の高い課題、最近解決した課題から課題画面に遷移する処理
    // 条表示・非表示の設定で表示画面が異なるため、分岐している
    goTaskDetail(diagResultItemId) {
      this.$store.dispatch('diag/setDiagResultItemId', diagResultItemId);
      let sectionNotUseFlag = this.$store.getters['diag/getSectionNotUseFlag'];
      if ( !sectionNotUseFlag ){
        this.$router.replace({path: '/diag/task/'+this.corpId+'/'+this.diagResultId+'/'+diagResultItemId+'/task/detailparam'});
      }else{
        this.$router.push({ name: 'task-detail' });
      }
    },
    changeEmployeeNumberType() {
      this.$refs.achievementDistribution.recreateGraph(this.corpId, this.diagResultId, this.employeeNumberType);
    },
    changeDiagTitle(value) {
      this.execChangeDiagTitle = value;
    },
    async deleteDiag(diagResultId) {
      const ans = confirm('削除しますか？');
      if (!ans) return;

      this.isRendering = true;
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/diag/deleteDiagResult', {
        diagResultId: diagResultId,
        corpId: this.corpId,
      });

      if (res.status === 200) {
        this.$toast.info('診断を削除しました');
        await this.getLatestDiagResultForCorporate(this.corpId);
        await this.getDiagResultList(this.corpId);
      } else {
        this.$toast.error('エラーが発生しました。');
      }
      this.$nextTick(() => {
        this.isRendering = false;
        this.isProcessing = false;
      });
    },
    emitSelectCorpList(params) {
      this.$store.dispatch('diag/setCorpId', params.corpId);
      this.$store.dispatch('diag/setCorpName', params.corpNm);
    },
    showTutorialModal(value) {
      this.isShowTutorial = value;
    },
  }
}
</script>

<style scoped>
.diagtitlechange-fade-enter-active {
  transition: all .2s ease;
}
.diagtitlechange-fade-leave-active {
  transition: all .2s ease;
}
.diagtitlechange-fade-enter
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-50px);
  opacity: 0;
}

.diagtitlechange-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-50px);
  opacity: 0;
}

.tutorialmodal-fade-enter-active {
  transition: all .2s ease;
}
.tutorialmodal-fade-leave-active {
  transition: all .2s ease;
}
.tutorialmodal-fade-enter {
  transform: translateY(-50px);
  opacity: 0;
}
.tutorialmodal-fade-leave-to {
  transform: translateY(-50px);
  opacity: 0;
}
</style>
